// eslint-disable-next-line
import themeRegistry from "./themes-registry.json";

// Use require.context to dynamically load theme files - webpack friendly
// In Jest environment, require.context may not be available, so use a fallback
let themeContext;
try {
  themeContext = require.context("./", true, /\.json$/);
} catch (error) {
  // Jest environment - mock the context function
  themeContext = () => ({});
  themeContext.keys = () => [];
}

export const loadBrandingTheme = (brand = "default", mode = "light") => {
  // Only load the exact theme requested - don't auto-fallback to default
  // Let the caller (resolveTheme) handle fallback logic
  const themeConfig = themeRegistry.themes[brand];

  if (!themeConfig) {
    return Promise.reject(new Error(`No theme configuration found for brand: ${brand}`));
  }

  try {
    const base = themeContext(themeConfig.base);
    const modeFile = themeContext(themeConfig.modes[mode]) || themeContext(themeConfig.modes.light);

    return Promise.resolve({
      tenantBase: base,
      mode: modeFile,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};
